import { Link } from 'react-router-dom'
import React from 'react'

export interface Link {
    url: string
    target?: string
    internal?: boolean
}

interface CustomLinkProps {
    link: Link
    content: React.ReactNode
}

const CustomLink: React.FC<CustomLinkProps> = ({ link, content }) => {
    const target = link.target || '_self'
    const className = 'text'

    if (link.internal) {
        return (
            <Link className={className} to={link.url} target={target}>
                {content}
            </Link>
        )
    }

    return (
        <a className={className} href={link.url} target={target}>
            {content}
        </a>
    )
}

export default CustomLink
